// extracted by css-extract-rspack-plugin
export default {"infoCard":"infoCard-xAlmOL","inputBox":"inputBox-XRRDWo","info":"info-nKRorc","infoIcon":"infoIcon-VMr8Uf"};